import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconIconSearch from "../../svg/icon-search.svg";

interface IProps {
    isSearchOpen: boolean;
    onOpenSearch: () => void;
    onCloseSearch: () => void;
}

export const SiteSearchBar = ({
    isSearchOpen,
    onOpenSearch,
    onCloseSearch,
}: IProps): React.ReactNode => {
    const openSearchButtonRef = React.useRef<HTMLButtonElement>(null);
    const searchButtonRef = React.useRef<HTMLButtonElement>(null);
    const hasInteracted = React.useRef(false);

    React.useEffect(() => {
        if (!hasInteracted.current) return;

        if (isSearchOpen && searchButtonRef.current) {
            searchButtonRef.current.focus();
        }

        if (!isSearchOpen && openSearchButtonRef.current) {
            openSearchButtonRef.current.focus();
        }
    }, [isSearchOpen]);

    const handleOpenSearch = () => {
        hasInteracted.current = true;
        onOpenSearch();
    };

    const handleCloseSearch = () => {
        hasInteracted.current = true;
        onCloseSearch();
    };

    const buttonClasses = classNames({
        "site-search-bar__button": true,
        "site-search-bar__button--hide": isSearchOpen,
    });

    return (
        <div className="site-search-bar">
            <button
                ref={openSearchButtonRef}
                className={buttonClasses}
                type="button"
                onClick={handleOpenSearch}
            >
                <SVG src={iconIconSearch} role="img" aria-hidden="true" />
                <span>{t`Search`}</span>
            </button>
            <form
                action="/search/"
                method="get"
                aria-hidden={!isSearchOpen}
                target="_top"
            >
                <button
                    ref={searchButtonRef}
                    type="submit"
                    aria-label={t`Search`}
                >
                    <SVG src={iconIconSearch} role="img" aria-hidden="true" />
                </button>
                <label
                    className="ada-screenreader-only"
                    htmlFor="top-search-nav-form"
                >
                    {t`Search`}
                </label>
                <input
                    id="top-search-nav-form"
                    type="text"
                    name="query"
                    // TODO(i18n): Wrap in t tagged template: title={t`Search Tempur-Pedic`}
                    title="Search Tempur-Pedic"
                    placeholder={t`Search`}
                />
                <button
                    type="button"
                    onClick={handleCloseSearch}
                    className="close"
                    aria-label={t`Close Search Container`}
                >
                    <span aria-hidden="true">x</span>
                </button>
            </form>
        </div>
    );
};
